import { Roles } from 'clickNgo/configs/roles'

export const CAMPAIGN_MANAGER_ROLES = [
  Roles.TRANSACTIONAL_MANAGER,
  Roles.ADMIN,
  Roles.HP_MGMT,
  Roles.SPV_IPBM,
  Roles.SPV_TR,
  Roles.SC_ADMIN,
]

export const CAMPAIGN_ISR_ROLES = [Roles.PROXIMITY, Roles.IPBM]

export const CAMPAIGN_SUPERVISOR_ROLES = [Roles.SPV_IPBM, Roles.SPV_TR, Roles.SC_ADMIN]
